import { Injectable } from '@angular/core';
import { Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';

import { Contract, Siterecord } from 'app/models';
import { ConfigurationStatusType } from 'app/models/enums';
import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const siterecordsByContractIdUrl = contractId => `${environment.apiUrl}/siterecords/contract/${contractId}`;
const siterecordByIdUrl = siterecordId => `${environment.apiUrl}/siterecorddetailExt/${siterecordId}`;
const saveSiterecordUrl = () => `${environment.apiUrl}/siterecordsExt`;
const allSiterecordsUrl = () => `${environment.apiUrl}/basesiterecords`;
const deletedSiterecordsUrl = () => `${environment.apiUrl}/basesiterecords?deleted=true`;
const deleteSiterecordUrl = siterecordId => `${environment.apiUrl}/siterecorddetail/${siterecordId}`;
const updateStatusSiterecordUrl = siterecordId => `${environment.apiUrl}/siterecords/${siterecordId}/`;
const rollbackDeleteSiterecord = siterecordId => `${environment.apiUrl}/siterecorddetailExt/${siterecordId}/undelete`;

@Injectable()
export class SiterecordService {
  public contract: Contract;

  constructor(private readonly httpService: HttpService) {}

  public getAllSiterecords(): Observable<Siterecord[]> {
    return this.httpService.get<Siterecord[]>(allSiterecordsUrl());
  }

  public getDeletedSiterecords(): Observable<Siterecord[]> {
    return this.httpService.get<Siterecord[]>(deletedSiterecordsUrl());
  }

  public getSiterecordsByContractId(contractId: number): Observable<Siterecord[]> {
    return this.httpService.get<Siterecord[]>(siterecordsByContractIdUrl(contractId));
  }

  public getSiterecordById(siterecordId: number): Observable<Siterecord> {
    return this.httpService.get<Siterecord>(siterecordByIdUrl(siterecordId));
  }

  public saveSiterecord(siterecord: Siterecord): Observable<Response> {
    return this.httpService.post(saveSiterecordUrl(), siterecord);
  }

  public updateSiterecord(siterecord: Siterecord): Observable<Response> {
    return this.httpService.put(siterecordByIdUrl(siterecord.id), siterecord);
  }

  public updateStatusSiterecord(siterecordId: number, status: ConfigurationStatusType): Observable<any> {
    const url = updateStatusSiterecordUrl(siterecordId);

    let verb;
    if (status === ConfigurationStatusType.CORRECT) {
      verb = 'approve';
    } else if (status === ConfigurationStatusType.ERROR) {
      verb = 'reject';
    } else {
      return Observable.throw(
        'Status other than ${ConfigurationStatusType.CORRECT} or ${ConfigurationStatusType.ERROR} not allowed'
      );
    }
    return this.httpService.post(url + verb, {});
  }

  public deleteSiterecord(id: number): Observable<Response> {
    return this.httpService.delete(deleteSiterecordUrl(id));
  }

  public rollbackDeleteSiterecord(id: number): Observable<Response> {
    return this.httpService.put(rollbackDeleteSiterecord(id), null);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/siterecord.service.ts